export const HAPPINESS_PAGE = 'reports/happiness/HAPPINESS_PAGE'
